export default async function deleteNotificationChannelGroupAsync(groupId: string): Promise<void> {
  console.debug('Notification channels feature is only supported on Android.');
}
